export abstract class DynFormsUserDataServiceInterface {
    abstract getUser(): Promise<any>;
}
